import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FcmService } from './fcm.service';
import * as moment from 'moment';
import { BehaviorSubject, Observable } from 'rxjs';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  isSessionExpired: boolean = false; //if set to true, can see session expired popup
  isReseller: boolean = false;
  appConfigObj: any = {};
  version = "";
  servicenear_version = "";
  sellerDetails: any = {};
  orderStatus: any[] = []; // store all order status here
  sellerConfiguration: any = {};
  sellerSettings = new BehaviorSubject<any>({});
  currentPlanDetails = new BehaviorSubject<any>({});
  isSubscriptionLoading: boolean = false;
  isShowLogOutConfirm: boolean;

  logoutTimeOut: any;
  sellerBasicDetails: any;
  onErrorImage: string = "https://bazaarnear.com/uploads/bazaarnear_95425101.jpg"

  private isFormVisible: () => boolean = () => false;
  isSellerDeactiveOrActivate: boolean = false;



  alertData = [
    {
      styleClass: "alert-warning",
      heading: "We need your attention!",
      message: "Your plan expires in @",
      message2: "Your plan expires in @. To continue enjoying our service please renew your plan before it expires."
    },
    {
      styleClass: "alert-danger",
      heading: "We need your attention!",
      message: "Your plan has expired",
      message2: "Your plan has expired. To continue using our service, please renew your plan."

    },
    {
      styleClass: "alert-success",
      heading: "Subscription is active!",
      message: "You have access to premium features"
    },
    {
      styleClass: "alert-success",
      heading: "Life time free!",
      message: "You are granted unlimited access for a lifetime."
    }
  ]

  parseHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient,
    private fcmService: FcmService,
    private router: Router,
    private route: ActivatedRoute,
    private utilityService: UtilityService) { }

  public convertToShortDate(date: any) {
    return moment(date).format("DD MMM YYYY");
  }

  public getLoginDetails() {
    return JSON.parse(localStorage.getItem('admin_Details') ?? "{}");
  }

  public updateAdminType() {
    let userDetails = this.getLoginDetails()
    if (Object.keys(userDetails).length) {
      this.isReseller = userDetails.IsReseller;
    } else {
      this.isReseller = false;
    }
  }

  public getBaseUrl(): String {
    let baseUrl = '';
    if (environment.appName === "Bazaarnear") {
      baseUrl = environment.bazaarnearUrlAuth;
    } else if (environment.appName === "Partson") {
      baseUrl = environment.partsonUrlAuth;
    } else if (environment.appName === "Digikari") {
      baseUrl = environment.easyvetUrlAuth;
    }
    return baseUrl;
  }

  public getNoAuthUrl() {
    let baseUrl = '';
    if (environment.appName === "Bazaarnear") {
      baseUrl = environment.bazaarnearUrl;
    } else if (environment.appName === "Partson") {
      baseUrl = environment.partsonUrl;
    } else if (environment.appName === "Digikari") {
      baseUrl = environment.easyvetUrl;
    }
    return baseUrl;
  }

  public getLoginUrl() {
    let loginURl = "";
    if (environment.appName === "Bazaarnear") {
      loginURl = environment.bazaarnearUrlLogin;
    } else if (environment.appName === "Partson") {
      loginURl = environment.partsonUrlLogin;
    } else if (environment.appName === "Digikari") {
      loginURl = environment.easyvetUrlLogin;
    }
    return loginURl;
  }

  //TO COPY ANYTHING TO CLIP BOARD
  public copyToClipBoard(text: string, customSuccessMsg?: string) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        const toastDetail = customSuccessMsg ? customSuccessMsg : `"${text}" Copied to clip board`;
        this.notify({ severity: 'success', summary: 'Success', detail: toastDetail })
      }).catch((error) => {
        this.notify({ severity: 'success', summary: 'Success', detail: `Failed to copy` })
      });
    }
  }


  public logoutUser(isSessionExpired?: boolean, isRefreshTokenInvalidOrClear?: boolean) {
    if (this.isSessionExpired) {
      this.isSessionExpired = false;
    }

    let appConfig = localStorage.getItem("appConfig");
    let uuid = localStorage.getItem("uuid");
    let userLoggedIn = localStorage.getItem('userLoggedIn');
    // decided before localStorage.clear() - it reads the seller's connected apps
    const isServicenear = this.isServicenearSession();
    this.sellerDetails = {};
    this.sellerConfiguration = {};
    this.sellerSettings.next({})
    this.currentPlanDetails.next({});

    localStorage.clear();

    if (uuid) {
      localStorage.setItem('uuid', uuid);
    }
    localStorage.setItem('userLoggedIn', userLoggedIn);
    localStorage.setItem('appConfig', appConfig);

    const thirdPartyAppUrl = this.utilityService.getParamValueFromAnyUrl('thirdpartyappurl');
    const thirdPartyUserKey = this.utilityService.getParamValueFromAnyUrl('thirdpartyuserkey');
    const servicenearAppUrl = thirdPartyAppUrl || decodeURIComponent(environment.thirdPartyAppURL);

    if (isRefreshTokenInvalidOrClear && thirdPartyUserKey !== null) {
      // ServiceNear session: always back to ServiceNear - no thirdpartyappurl in the URL falls back to
      // servicenear.in (was /admin/nofound, a route that does not exist, so the seller landed on the 404 page)
      window.location.href = servicenearAppUrl + '?logout=true';
    } else if (isServicenear && thirdPartyUserKey === null) {
      // ServiceNear seller without the key in the URL: the Tobeonline login page cannot sign them in -> ServiceNear login
      window.location.href = servicenearAppUrl + '/#!/LoginScreen';
    } else {
      if (isSessionExpired) {
        const rawHash = window.location.hash.replace(/^#/, '');; // e.g., "#/servicenear/dashboard?..."
        this.router.navigate(['/public/login'], { queryParams: { redirect: rawHash, sessionexpired: true }, queryParamsHandling: 'merge' });
      } else {
        // ServiceNear key goes into queryParams (not spread into the extras): when the first page of a visit
        // failed there is no current URL to merge from, and without the key the login page cannot sign in again
        const thirdPartyParams = thirdPartyUserKey ? { thirdpartyuserkey: thirdPartyUserKey, thirdpartyappurl: thirdPartyAppUrl } : {};
        this.router.navigate(['/public/login'], { queryParams: thirdPartyParams, queryParamsHandling: 'merge' });
      }
    }
  }

  /**
   * ServiceNear seller or Tobeonline seller - decides which login a logout / lost session goes to:
   *  1. thirdpartyuserkey in the URL        -> ServiceNear (opened from the ServiceNear app)
   *  2. logged in: the seller's IncomingApps (incoming_apps_connection_config, saved on login) has Servicenear
   * Anything else is Tobeonline - also every logged-out visit without the key: after a ServiceNear seller logs out,
   * the next person on the device may be a Tobeonline seller (remembering the last app sent them to ServiceNear).
   */
  public isServicenearSession(): boolean {
    if (this.utilityService.getParamValueFromAnyUrl('thirdpartyuserkey') !== null) {
      return true;
    }
    const loginDetails = this.getLoginDetails();
    if (loginDetails?.UserType === 'superadmin') {
      return false;   // incomingApps may hold the seller superadmin is viewing - superadmin always logs in on Tobeonline
    }
    return !!loginDetails?.UserID && (localStorage.getItem('incomingApps') ?? '').toLowerCase().includes('servicenear');
  }

  public sessionLogout(isRefreshTokenInvalid?: boolean) {
    if (!this.router.url.startsWith('/public/login') && !this.isSessionExpired) {
      this.isSessionExpired = true;
      this.logoutUser(true, isRefreshTokenInvalid);
    }
  }

  /** landingPath: from OnboardingService.resolveLandingRoute() (onboarding / first page the plan enables); a ?redirect= link wins. */
  public navigateLoginUser(landingPath: string = '/dashboard/summary') {
    const params = this.route.snapshot.queryParams;
    const redirect = params['redirect'];
    const url = decodeURIComponent(redirect);
    if (!redirect || !url) {
      this.router.navigateByUrl(landingPath, { replaceUrl: true });
    } else {
      const [path, queryString] = url.split('?');
      const queryParams = this.utilityService.parseQueryParams(queryString || '');
      this.router.navigate([path], { queryParams });
    }
  }

  // THEME COLOR SETTING
  private setSellerTheme() {
    document.documentElement.style.setProperty('--baseColor', this.appConfigObj.baseColor);
    document.documentElement.style.setProperty('--baseColorLight', this.appConfigObj.baseColorLight);
    document.documentElement.style.setProperty('--textColor', this.appConfigObj.textColor);
  }

  //## APP CONFIGURATION ##
  public getAppConfig() {
    let configJSON = localStorage.getItem("appConfig");
    if (configJSON) {
      this.appConfigObj = JSON.parse(configJSON);
    }

    const configFilePath = `assets/config${environment.appName}.json`;

    if (this.appConfigObj?.appname == environment.appName && this.appConfigObj?.browserType == environment.browserType) {
      this.orderStatus = this.appConfigObj?.orderStatus ?? [];
      this.version = this.appConfigObj?.version ?? "";
      this.servicenear_version = this.appConfigObj?.servicenear_version ?? "";
      this.checkIsNotificationEnabled();
    }

    this.http.get(configFilePath, this.parseHeaders).subscribe((res: any) => {
      if (res.version != this.appConfigObj?.version) {
        localStorage.setItem('appConfig', JSON.stringify(res));
        location.reload();
      }
    },
      (error) => {
        console.error("Error fetching config file:", error);
        // Handle the error as needed
      }
    );
  }

  public setAppConfig(key: string, defaultValue: boolean) {
    // return (key in this.appConfigObj) ? this.appConfigObj[key] : defaultValue;
    return this.appConfigObj[key] ?? defaultValue;
  }

  public checkIsNotificationEnabled() {
    if (this.setAppConfig('admin_mobile_notification_web', false)) {
      this.fcmService.initNotification();
    }
  }

  // TOAST MESSAGE METHOD
  public notify(message: any) {
    //   severity: 'success',   => Severity level of the message, valid values are ['success', 'info', 'warn' and 'error']
    //   summary: 'Success',    => Summary text of the message.
    //   detail: '',            => Detail text of the message.
    //   life: 3000,            => Number of time in milliseconds to wait before closing the message.
    //   sticky: false          => Whether the message should be automatically closed based on life property or kept visible.

    // ## SUCCESS ##
    // this.configService.notify({severity: 'success', summary: 'Success', detail: ""})
    // ## FAILED ##
    // this.configService.notify({severity: 'error', summary: 'Failed', detail: ""})

    // this.msgService.add({
    //   severity: message?.severity ?? 'info',
    //   summary: message?.summary ?? '',
    //   detail: message?.detail ?? '',
    //   life: message?.life ?? 5000,
    //   sticky: message?.sticky ?? false
    // });
  }


  //Subscription API
  public getSubscriptionDetails() {
    const userDetails = this.getLoginDetails();
    if (userDetails?.Uuid) {
      this.isSubscriptionLoading = true;
      this.getSellerSubscriptionDetails().subscribe((res: any) => {
        this.isSubscriptionLoading = false;
        if (res?.Result == "Success" && res?.ResponseData) {
          this.processPlanDetails(res.ResponseData);
        }
      }, (err: HttpErrorResponse) => {
        this.isSubscriptionLoading = false;

      })
    }
  }

  private processPlanDetails(ResponseData: any) {
    let subscriptionPlanDetails = ResponseData;
    let SubscriptionDetails = JSON.parse(subscriptionPlanDetails?.SubscriptionDetails ?? "null");
    subscriptionPlanDetails.remainingDays = moment(subscriptionPlanDetails.SubscriptionExpiresOn).diff(moment(), "days");

    if (subscriptionPlanDetails.IsLifeTimeFree) {
      // subscriptionPlanDetails.validityPercentage = 25;
      subscriptionPlanDetails.remainingDays = 0;
      subscriptionPlanDetails.alert = this.alertData[3];
      subscriptionPlanDetails.expiryDateString = "Unlimited";

    } else if (subscriptionPlanDetails.remainingDays > 10) { // remainingDays 10 +
      subscriptionPlanDetails.alert = this.alertData[2];
      subscriptionPlanDetails.validityPercentage = 100 - ((subscriptionPlanDetails.remainingDays / subscriptionPlanDetails.SubscriptionPeriod) * 100);
      subscriptionPlanDetails.expiryDateString = this.convertToShortDate(subscriptionPlanDetails.SubscriptionExpiresOn);

    } else if (subscriptionPlanDetails.remainingDays >= 0) { // remainingDays 0 to 10
      subscriptionPlanDetails.alert = this.alertData[0];
      subscriptionPlanDetails.expiryDateString = this.convertToShortDate(subscriptionPlanDetails.SubscriptionExpiresOn);

      let replaceString = subscriptionPlanDetails.remainingDays > 1 ? subscriptionPlanDetails.remainingDays + ' days' : subscriptionPlanDetails.remainingDays + ' day';
      replaceString = "<b>" + replaceString + "</b>"
      subscriptionPlanDetails.alert.message = subscriptionPlanDetails.alert.message.replace("@", replaceString);
      subscriptionPlanDetails.alert.message2 = subscriptionPlanDetails.alert.message2.replace("@", replaceString);
      subscriptionPlanDetails.validityPercentage = 100 - ((subscriptionPlanDetails.remainingDays / subscriptionPlanDetails.SubscriptionPeriod) * 100);

    } else {  //remainingDays -ve
      subscriptionPlanDetails.alert = this.alertData[1];
      subscriptionPlanDetails.SubscriptionName = "No active plan!"
      subscriptionPlanDetails.expiryDateString = "Expired";
      subscriptionPlanDetails.RemainingCustomerCount = 0;
      subscriptionPlanDetails.RemainingOrderCount = 0;
      subscriptionPlanDetails.RemainingProductCount = 0;
      subscriptionPlanDetails.remainingDays = 0;
      subscriptionPlanDetails.validityPercentage = 100;
    }

    if (SubscriptionDetails) {
      SubscriptionDetails.Description = SubscriptionDetails.Description.split("#")
      subscriptionPlanDetails.subscriptionDetails = SubscriptionDetails;
    }
    this.currentPlanDetails.next(subscriptionPlanDetails);
    this.isSubscriptionLoading = false;
  }

  public getSellerSubscriptionDetails() {
    const sendingData = {
      sellerID: 0
    }
    const url = this.getBaseUrl() + "/Subscription/GetSellerSubscriptionDetails";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  setFallbackImage(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = this.onErrorImage;
  }

  //Theme settings API
  public getSettingsBySellerId() {
    const userDetails = this.getLoginDetails();
    if (userDetails?.Uuid) {
      this.getSellerSettingsBySellerId({ filters: "All"}).subscribe((res: any) => {
        if (res?.Result == "Success" && res?.ResponseData) {
          this.isSellerDeactiveOrActivate = res?.ResponseData?.IsActive;
          const SellerSettingsData = JSON.parse(res?.ResponseData.WebsiteTheme);
          const SellerSocialMedia = JSON.parse(res?.ResponseData.SocialMediaLinks);
          SellerSettingsData.SocialMediaLinks = SellerSocialMedia;
          this.sellerConfiguration = SellerSettingsData;
          this.sellerSettings.next(SellerSettingsData);
          localStorage.setItem('sellerThemeDetails', res?.ResponseData.WebsiteTheme)
          localStorage.setItem('generalSettings', res?.ResponseData?.SettingsData ?? null);
          localStorage.setItem('incomingApps', res?.ResponseData?.IncomingApps ?? null);
        }

      }, (err: HttpErrorResponse) => {

      })
    }
  }

  public getSellerSettingsBySellerId(params: any) {
    const sendingData = {
      sellerID: 0,
      filters: params.filters
    }
    const url = this.getBaseUrl() + "/Subscription/GetSellerSettingsBySellerId";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  getSellerDetailsAndUpdateBasicDetails(subDomain: string): void {
    this.getSellerDetailsBySubdomain(subDomain).subscribe((res: any) => {
      if (res?.Result == 'Success' && res?.ResponseData != "No Seller Exist") {
        this.sellerBasicDetails = res.ResponseData;
      }
    }, (err: HttpErrorResponse) => {
    });
  }

  getSellerDetailsBySubdomain(subDomain: string): Observable<any> {
    const url = this.getNoAuthUrl() + "/User/GetSellerDetailsBySubDomainForAdmin?subDomain=" + subDomain;
    return this.http.get(url);
  }

  public generateUnpublishedStoreToken() {
    const userDetails = this.getLoginDetails();
    const sendingData = {
      sellerID: 0,
      updatedBy: userDetails.UserID,
    }
    const url = this.getBaseUrl() + '/Seller/GenerateUnpublishedStoreToken';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAIGeneratedDescription(searchKey: any) {
    let modifiedSearchKey = `${searchKey}. Generate Name, Search Keywords, SEO Keywords, and Description with bullet points. Please ensure the description is formatted as a list of bullet points.`;
    const userDetails = this.getLoginDetails();
    const sendingData = {
      sellerId: 0,
      createdBy: userDetails.UserID,
      searchKey: modifiedSearchKey
    }
    const url = this.getBaseUrl() + "/Products/GetAIGeneratedData";
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getAIGeneratedWebsiteContent(prompt: any) {
    const modifiedPrompt = `${prompt}

    Please generate structured website content with the following labels, formatted exactly as shown below. Each label should be bolded and followed by its content on a new line:
    
**Formatting & Content Instructions:**
- All labels must appear exactly as shown below, bolded and on their own line.
- **Site Description** should be exactly 3 sentences long.
- **Main descriptions** (e.g. SEO Description, Features Description, Working Flow Data Description, Help Video Description, FAQ Description, Screenshot Description, About Description) should each be 4–5 sentences long.
- **Sub descriptions** (e.g. About Description 1, About Description 2, Feature 1/2/3/4 Description) should each be 3 sentences long.
- **FAQ answers** (Answer 1 to Answer 5) should each be 3 sentences long.
- **Footer Description** should be 2–3 sentences describing the brand (no copyright or year).

    **Site Header:** ...
    **Site Description:** ...
    **About Section Heading:** ...
    **About Header:** ...
    **About Description:** ...
    **About Section 1:** ...
    **About Heading 1:** ...
    **About Description 1:** ...
    **About Section 2:** ...
    **About Heading 2:** ...
    **About Description 2:** ...
    **USP Section Heading:** ...
    **USP Name 1:** ...
    **USP Description 1:** ...
    **USP Name 2:** ...
    **USP Description 2:** ...
    **USP Name 3:** ...
    **USP Description 3:** ...
    **Feature 1 Name:** ...
    **Feature 1 Description:** ...
    **Feature 2 Name:** ...
    **Feature 2 Description:** ...
    **Feature 3 Name:** ...
    **Feature 3 Description:** ...
    **Feature 4 Name:** ...
    **Feature 4 Description:** ...
    **Screenshot Section Heading:** ...
    **Screenshot Menu Header:** ...
    **Screenshot Description:** ...
    **FAQ Heading:** ...
    **FAQ Menu Header:** ...
    **FAQ Description:** ...
    **Question 1:** ...
    **Answer 1:** ...
    **Question 2:** ...
    **Answer 2:** ...
    **Question 3:** ...
    **Answer 3:** ...
    **Question 4:** ...
    **Answer 4:** ...
    **Question 5:** ...
    **Answer 5:** ...
    **Question 6:** ...
    **Answer 6:** ...
    **Help Video Section Heading:** ...
    **Help Video Heading:** ...
    **Help Video Title:** ...
    **Help Video Menu Header:** ...
    **Help Video Description:** ...
    **Footer Description:** ...
    
    **Working Flow Data Heading:** ...
    **Menu Working Flow Data Heading:** ...
    **Working Flow Data Description:** ...
    **Step 1 Heading:** ...
    **Step 1 Description:** ...
    **Step 2 Heading:** ...
    **Step 2 Description:** ...
    **Step 3 Heading:** ...
    **Step 3 Description:** ...
    
    **Features Heading:** ...
    **Menu Features Heading:** ...
    **Features Description:** ...

    **SEO Keywords:** ...
    **SEO Title:** ...
    **SEO Description:** ...
    `;
    const userDetails = this.getLoginDetails();
    const sendingData = {
      sellerId: 0,
      createdBy: userDetails.UserID,
      searchKey: modifiedPrompt
    };
    const url = this.getBaseUrl() + "/Products/GetAIGeneratedData";
    return this.http.post(url, sendingData, this.parseHeaders);
  } 

  public getCurrentPlan() {
    let userDetails = this.getLoginDetails();
    var url = environment.subscriptionApiBaseUrl + '/subscriptionApi/GetCustomerActiveSubscriptionPlan?customerId=' + userDetails.UserID;
    return this.http.get(url, this.parseHeaders)
  }

  // Seller onboarding - the plan list comes from SubscriptionApi/GetAllSubscriptionPlansForSuperAdmin (third-party.service)
  public subscribeSellerToPlan(params: any) {
    const sendingData = {
      subscriptionPlanId: params.subscriptionPlanId
    }
    const url = environment.subscriptionApiBaseUrl + '/SubscriptionApi/SubscribeSellerToPlan';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getPendingPayment() {
    var url = environment.subscriptionApiBaseUrl  + '/SubscriptionApi/GetPendingSubscriptionBills'
    return this.http.get(url, this.parseHeaders)
  }

  public getSubscriptionBillsHistory(params?: any) {
    let userDetails = this.getLoginDetails();
    const sendingData = {
      isDateCheck: params?.isDateCheck ?? false,
      fromDateUnix: params?.fromDateUnix ?? 0,
      toDateUnix: params?.toDateUnix ?? 0,
      searchKey: params?.searchKey ?? "",
    }
    const url = environment.subscriptionApiBaseUrl  + '/SubscriptionApi/GetSubscriptionBillsHistory';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getCurrentPlanBySellerUuid(params: any) {
    let userDetails = this.getLoginDetails();
    var url = environment.subscriptionApiBaseUrl + '/subscriptionApi/GetCustomerActiveSubscriptionPlanByUuidForSuperAdmin?uuid=' + params.uuid;
    return this.http.get(url,this.parseHeaders)
  }

  public getPendingPaymentBySellerUuid(params: any) {
    var url = environment.subscriptionApiBaseUrl + '/SubscriptionApi/GetPendingSubscriptionBillsByUuidForSuperAdmin?uuid=' + params.uuid
    return this.http.get(url, this.parseHeaders)
  }

  public getSubscriptionBillsHistoryBySellerUuid(params: any) {
    let userDetails = this.getLoginDetails();
    const sendingData = {
      isDateCheck: false,
      fromDateUnix: 0,
      toDateUnix: 0,
      searchKey: "",
      uuid: params.uuid
    }
    const url = environment.subscriptionApiBaseUrl + '/SubscriptionApi/GetSubscriptionBillsHistoryByUuidForSuperAdmin';
    return this.http.post(url, sendingData,this.parseHeaders);
  }

}
